module.exports = __webpack_public_path__ + "static/img/0015.b327d16c.png";